import { render, staticRenderFns } from "./MessageFilterList.vue?vue&type=template&id=592e5204"
import script from "./MessageFilterList.vue?vue&type=script&lang=js"
export * from "./MessageFilterList.vue?vue&type=script&lang=js"
import style0 from "./MessageFilterList.vue?vue&type=style&index=0&id=592e5204&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports